// Replicates react-avatar's internal color algorithm so colors are consistent
// across avatars and any UI that needs to match them (e.g. message bubble borders).
// const AVATAR_COLORS = ['#d73d32', '#7e3794', '#4285f4', '#67ae3f', '#d61a7f', '#ff4080'];

import { hsl } from 'polished';

export function getAvatarColor(name: string): string {
  if (!name) return 'hsl(0, 0%, 45%)'; // Default gray if no name

  // 1. Generate a consistent hash from the string
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    // Standard bitwise hashing to get a large integer
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  // 2. Map the hash to a Hue (0 - 360)
  const hue = Math.abs(hash % 360);

  // 3. Use fixed Saturation and Lightness for readability
  // Saturation: 65% (Vibrant but not neon)
  // Lightness: 40% (Dark enough for white text to pass WCAG contrast)
  return hsl(hue, 0.65, 0.4);
}
// export function getAvatarColor(name: string): string {
//   if (!name) return AVATAR_COLORS[0];
//   const charCodes = [...name].map(l => l.charCodeAt(0));
//   const m = AVATAR_COLORS.length;
//   const a = (charCodes.length % (m - 1)) + 1;
//   const c = charCodes.reduce((cur, next) => cur + next) % m;
//   let random = charCodes[0] % m;
//   for (let i = 0; i < charCodes.length; i++) random = (a * random + c) % m;
//   return AVATAR_COLORS[random];
// }
